import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { SuccessData } from 'types/api';

export const projectDateMutations = getMutations({
  answerProjectDateChange: {
    action: async (payload: {
      justification: string;
      date: string | null;
      approved: boolean;
      project: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/projects/date-change-response',

        payload,
      });
    },

    messages: {
      suppressSuccess: true,

      error: (t) => ({
        title: t('error-while-executing-date-change-request'),
        description: t('try-again-in-a-few-moments') as string,
      }),
    },
  },

  requestProjectDateChange: {
    action: async (payload: {
      justification: string;
      date: string;
      project: string;
    }): Promise<SuccessData> => {
      return executeApiCall({
        path: '/projects/date-change-request',

        payload,
      });
    },

    messages: {
      suppressSuccess: true,

      error: (t) => ({
        title: t('date-change-failed'),
        type: 'error',
      }),
    },
  },
});
